import React from "react";
import { Grid } from "@material-ui/core";
import TeamSummaryCard from "../team-summary-card";
import { injectIntl, InjectedIntlProps } from "react-intl";
import messages from "./Teams.intl";
import { ITeam } from "../../types";
import ScoutCard from "../scout-card";
import useIsAdmin from "../../hooks/useIsAdmin";
import { styled } from "@material-ui/styles";
import { IStyledArguments } from "../../types/styled-arguments";

interface IGroupFilterState {
  items: ITeam[];
}

const EmptyState = styled("div")(({ theme }: IStyledArguments) => ({
  textAlign: "center",
  padding: theme.spacing(8, 2),
  background: theme.palette.extra.backgroundGrey,
  borderRadius: "20px",
  border: `2px dashed ${theme.palette.extra.borderColor}`,
  color: theme.palette.text.secondary,
  fontSize: "1.1rem",
  margin: theme.spacing(2),
}));

const GroupList = injectIntl<IGroupFilterState & InjectedIntlProps>(
  ({ items, intl }) => {
    if (!items.length) {
      return <EmptyState>{intl.formatMessage(messages.noTeams)}</EmptyState>;
    }

    return (
      <Grid container spacing={4} data-testid="group-cards">
        {items.map((group) => {
          return (
            <Grid item xs={12} sm={6} key={`grid-item-${group.id}`}>
              <TeamSummaryCard
                key={group.id}
                id={group.id}
                // squad={group.squad}
                // title={group.name}
                // subtitle={intl.formatMessage(messages.leadersCount, {
                //   n: group.squad.length
                // })}
                // foundation={group.foundationYear}
                team={group}
              />
            </Grid>
          );
        })}
        {useIsAdmin() && (
          <Grid item xs={12} sm={6} key={`grid-item-scout1`}>
            <ScoutCard />
          </Grid>
        )}
      </Grid>
    );
  }
);

export default GroupList;
